import { useCallback, useSyncExternalStore } from 'react';
import { useCan as useRbacCan } from '@dreamtree-org/tenancy/react';
import { getAuth, subscribe } from './permissions';

/** Current auth user (re-renders on login/logout). */
export function useAuth() {
  return useSyncExternalStore(subscribe, getAuth, getAuth);
}

/**
 * Returns can(module, action, scope = 'org') bound to the current user — the app's call
 * shape over rbac-authz/react's useCan(), which reads <RbacProvider> (mounted in App.jsx
 * from this store). Memoised: stable until the permission set changes.
 */
export function useCan() {
  const can = useRbacCan();
  return useCallback((module, action, scope = 'org') => can(`${module}.${action}.${scope}`), [can]);
}
